
import React from 'react'
import { Button, Form, Input, message, Tabs } from 'antd';
import Config from '../../config/Config';
import WidgetAjax from '../../widget/WidgetAjax';
import WidgetModal from '../../widget/WidgetModal';
import GZHbind from '../com/QRcode/GZHbind';

let path = Config.getBasePath();
let filePath = Config.getFilePath();
let application = Config.getApplication();
const sourcePath = Config.getSourcePath();
class personalCenter extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      settingData: [
        { name: '修改用户名', tips: '暂未上线', disabled: true, operation: this.nameOpen, bindButtonText: '立即修改', placeholder: "登录系统时需要输入的用户名，您有一次可修改的机会" },
        { name: '绑定微信', tips: '未绑定', disabled: false, operation: this.GzhOpen, bindButtonText: '立即绑定', placeholder: "授权绑定后，可使用微信扫描登录，并通过公众号接受消息提醒" },
        { name: '手机号', tips: '暂未上线', disabled: true, bindButtonText: '立即更换', placeholder: "手机号后期用于找回密码、验证码登录、接受短信提醒等，当前功能暂未上线，敬请期待" },
      ],
      user_info: {},
    }
    this.gzhRef = null
  }

  componentDidMount() {
    this.info();
    this.getUserInfo();
    this.isCheck();
  }

  info = () => {
    const { settingData } = this.state;
    const onInfo = (res) => {
      if (res.status == 0) {
        if (res.result && res.result.renamings == 0) {
          const updatedList = [...settingData];
          updatedList[0] = {
            name: '修改用户名',
            tips: '不可修改',
            disabled: true,
            classStyle: "sg-disabled",
            operation: this.nameOpen,
            bindButtonText: '立即修改',
            placeholder: "登录系统时需要输入的用户名，您有一次可修改的机会"
          };
          this.setState({ settingData: updatedList })
        }
      }
    }
    WidgetAjax.ajax({ url: path + "/info", callback: onInfo })
  }


  getUserInfo = () => {
    const onGetUser = (res) => {
      if (res.status == 0) {
        this.setState({ user_info: res.result })
      }
    }
    WidgetAjax.ajax({ url: path + "/info", callback: onGetUser })
  }


  isCheck = () => {

    const onCheck = (res) => {

      if (res.result && res.result.openid) {
        this.setState({ bindGzh: true })
      } else {
        this.setState({ bindGzh: false })
      }
    }

    WidgetAjax.ajax({ url: path + "/weixin/bind_check", params: { application }, callback: onCheck });

  }


  nameOpen = () => {
    this.updateRef.open();
  }

  GzhOpen = () => {
    if (this.gzhRef && this.gzhRef.open) this.gzhRef.open();
  }

 

  unbind = () => {
    const { user_info } = this.state;

    const onUnBind = (res) => {
      if (res.status == 0) {
        message.success("解绑成功!");
        this.refresh();
      } else {
        message.error("解绑失败!")
      }
    }
    WidgetAjax.ajax({ url: path + "/weixin/unbind", params: { UID: user_info.UID, application }, callback: onUnBind });

  }

  refresh = () => {
    this.info();
    this.getUserInfo();
    this.isCheck();
  }


  render() {
    const { settingData, bindGzh } = this.state;

    return <div>


      <div className='controlPanel'>
        <span className='basic_Title'>基本设置</span>

        <div className='basic_box '>
          {
            settingData.map((item) => {
              return <div className='basic_item' key={item.index}>
                <label>{item.name}</label>
                <div className='basic_placeholder'>{item.placeholder}</div>

                <div className='basic_op'>
                  {
                    bindGzh && item.name === '绑定微信' ?
                      <div className={`basic_tips ${item?.classStyle}`} style={{ color: '#2DB10C', display: 'block' }}>
                        <div style={{ display: 'flex', justifyContent: "center", alignItems: "center" }}><img src={require("../../img/dataSource/tips_green.png")} /> 已绑定</div>
                      </div>
                      : <div className={`basic_tips ${item?.classStyle}`}> <img src={require("../../img/pinzhunzhun/dataSource/tips.png")} /> {item.tips}</div>
                  }
                  {
                    bindGzh && item.name === '绑定微信' ?
                      <>
                        <a style={{ marginRight: '8px' }} onClick={() => this.GzhOpen()}>重新绑定</a>
                        <a onClick={() => { this.unbind() }}>解绑</a>
                      </> :
                      <Button type="primary" disabled={item.disabled} onClick={() => item.operation ? item.operation() : {}}>{item.bindButtonText}</Button>

                  }
                </div>

              </div>
            })
          }
        </div>
      </div>



      <WidgetModal options={{ title: '修改用户名', width: 600 }} isHide={true} ref={ref => this.updateRef = ref} onOk={this.update_Name}>
        <Form ref={ref => this.updateform = ref} labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}  >
          <Form.Item label="新用户名" name="username">
            <Input autocomplete="new-password" />
          </Form.Item>
          <Form.Item label="验证密码" name="password">
            <Input.Password autocomplete="new-password" />
          </Form.Item>
        </Form>
      </WidgetModal>
      {
          <GZHbind onRef={ref => this.gzhRef = ref} onOk={this.refresh} />
        }


    </div>
  }
}

export default personalCenter;